var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContainerBody',[_c('div',{staticClass:"ui divider horizontal"},[_vm._v("Mnemônicos Contrato")]),_c('TreeList',{attrs:{"label":"Lista de Mnemônicos","listItems":_vm.listMnemonicos},on:{"addTextModal":_vm.copiarMnemonico}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }